"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Card } from "@/components/ui/card";
import { PenTool, Monitor, Share2, ChartBar, Search, Target, ShoppingCart, Settings, Camera, ShieldCheck, CalendarDays, Mail, Zap } from "lucide-react";
const getIconForService = (title: string) => {
  const normalizedTitle = title.toLowerCase();
  if (normalizedTitle.includes("branding")) return PenTool;
  if (normalizedTitle.includes("website") || normalizedTitle.includes("web")) return Monitor;
  if (normalizedTitle.includes("redes sociais") || normalizedTitle.includes("social")) return Share2;
  if (normalizedTitle.includes("dados") || normalizedTitle.includes("data")) return ChartBar;
  if (normalizedTitle.includes("google")) return Search;
  if (normalizedTitle.includes("ads") || normalizedTitle.includes("publicidade")) return Target;
  if (normalizedTitle.includes("marketplace")) return ShoppingCart;
  if (normalizedTitle.includes("software") || normalizedTitle.includes("sistema")) return Settings;
  if (normalizedTitle.includes("foto") || normalizedTitle.includes("vídeo") || normalizedTitle.includes("video")) return Camera;
  if (normalizedTitle.includes("cibersegurança") || normalizedTitle.includes("segurança")) return ShieldCheck;
  if (normalizedTitle.includes("feira") || normalizedTitle.includes("evento")) return CalendarDays;
  if (normalizedTitle.includes("email") || normalizedTitle.includes("e-mail")) return Mail;
  return Zap;
};
function ServicesGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="225894" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-[280px] rounded-3xl bg-muted/50 animate-pulse border border-border" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Não foi possível carregar os planos de serviço.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Nenhum plano de precificação encontrado.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => {
      const title = post.customFields?.titulo || post.title;
      const description = post.customFields?.descricao || "Solução escalável e otimizada para o crescimento do seu negócio digital.";
      const Icon = getIconForService(title);
      const labelNumber = (i + 1).toString().padStart(2, '0');
      const isFeatured = i === 1;
      return <Link key={post.id} to={post.link || "/HomePage"} data-index={i} className="group block h-full outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-3xl">
            <Card className={`h-full border-none rounded-3xl p-6 md:p-8 flex flex-col gap-6 transition-all duration-300 shadow-md hover:shadow-xl hover:-translate-y-1 ${isFeatured ? 'bg-primary text-primary-foreground' : 'bg-card text-card-foreground'}`}>
              <div className="flex justify-between items-start">
                <span className={`text-xs font-mono tracking-wider ${isFeatured ? 'text-primary-foreground/70' : 'text-muted-foreground'}`}>PLAN.{labelNumber}</span>
                <Icon className={`w-8 h-8 stroke-[1.5] transition-transform duration-300 group-hover:scale-110 ${isFeatured ? 'text-primary-foreground' : 'text-primary'}`} />
              </div>
              <div className="mt-auto pt-8">
                <h3 className="text-xl font-bold font-default mb-3">{title}</h3>
                <p className={`text-sm leading-relaxed line-clamp-3 ${isFeatured ? 'text-primary-foreground/90' : 'text-muted-foreground'}`}>{description}</p>
              </div>
            </Card>
          </Link>;
    })}
    </div>;
}
export default function PremiumServices() {
  const wp_query_params = {
    post_type: "service",
    per_page: 12,
    orderby: "title",
    order: "asc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}